import styled from 'styled-components';

export const HeaderButtons = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;

    @media (max-width: 768px) {
        gap: 0px;
    }
`;
